import { Link } from 'react-router-dom'
import { FAQ_ENTRIES } from '@sh/shared'
import { Article } from './Article.js'

/**
 * The questions, rendered from the same array the server turns into `FAQPage`
 * structured data.
 *
 * Neither side writes its own copy of an answer. Structured data that does not
 * match the visible page is penalised by search engines, but the reason not to
 * do it is plainer than that: an answer that is right here and wrong in the
 * markup is wrong for whoever reads the markup.
 */
export function Faq() {
  return (
    <Article
      title="Questions"
      standfirst={
        <>
          What this is, what it needs, and what it deliberately will not do. The short version: you
          need five to ten people in one room and a phone each, and nothing else.
        </>
      }
    >
      {FAQ_ENTRIES.map((entry) => (
        <section className="card" key={entry.q}>
          <h2 className="card__title">{entry.q}</h2>
          <p className="card__hint">{entry.a}</p>
        </section>
      ))}

      <section className="card">
        <h2 className="card__title">Something else</h2>
        <p className="card__hint">
          <Link to="/rules">The full rules</Link> cover the game itself.
        </p>
      </section>
    </Article>
  )
}
